// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1ebfcee2","453":"737544d5"}[chunkId] + ".chunk.js";
};